import { Controller } from "@hotwired/stimulus"

// The FAQ's filter box (docs/07 FAQs).
//
// Every answer is already on the page, so filtering is hiding rather than
// fetching: a question you can read beats a spinner, and the page keeps
// working with no JavaScript at all — the box is the only thing that stops.
//
// Two things that are invisible when wrong: a category whose every question is
// hidden must take its heading with it, and a search matching nothing has to
// say so rather than leaving a blank page.
export default class extends Controller {
  static targets = ["search", "count", "empty"]

  filter() {
    const term = this.searchTarget.value.trim().toLowerCase()
    const questions = this.element.querySelectorAll("[data-faq]")
    let shown = 0

    questions.forEach((question) => {
      const matches = term === "" || question.dataset.question.includes(term)
      question.hidden = !matches
      if (matches) shown += 1
      // An open answer that is then hidden stays open underneath, and
      // reappears expanded for a search it has nothing to do with.
      if (!matches) question.open = false
    })

    this.element.querySelectorAll("[data-category]").forEach((group) => {
      group.hidden = group.querySelectorAll("[data-faq]:not([hidden])").length === 0
    })

    this.countTarget.hidden = term === ""
    this.countTarget.textContent = `${shown} of ${questions.length}`
    this.emptyTarget.hidden = shown > 0
  }
}
